const initialState = {
  savedAnswers: {},
  preventUnitsChanges: {},
};

function questions(state = initialState, action) {
  switch (action.type) {
    case 'SET_QUESTIONS':
      return {
        ...state,
        list: action.payload,
      };

    case 'QUESTIONS_GO_TO':
      return {
        ...state,
        currentQuestion: action.payload,
      };

    case 'SET_TOTAL_QUESTIONS':
      return {
        ...state,
        totalQuestions: action.payload,
      };

    case 'SAVE_ANSWERS':
      return {
        ...state,
        savedAnswers: action.payload,
      };

    case 'PREVENT_UNITS_CHANGES':
      return {
        ...state,
        preventUnitsChanges: action.payload,
      };

    default:
      return state;
  }
}

export default questions;
